export default "__VITE_ASSET__BCm5nB0v__"